import styled from 'styled-components'

export const TableDiv = styled.div`
display: flex;
width: 100%;
font-size: .813rem;
table, th, td {
  border: 1px solid var(--c4);
  border-collapse: collapse;
  font-family: 'Roboto','sans-serif';
}

table{
    width: 100%;
}

td{
    max-width: 5rem;
    padding: .75rem 1.25rem;
}

th{
    max-width: 6rem;
    padding: .325rem .75rem;
}

td{
    transition: 2s;
}

td{
    background: var(--AzulOpacoBg);
}
thead>tr{
    background: var(--c2);
}
`

export const StyledTd = styled.td`
    color: ${props => props.theme};
    font-weight: bold;
`
